import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { ITableHeader } from '../../../common/components/TableList/typings';
import { IRootState } from '../../../typings';
import { fetchTournamentAwards } from '../actions';
import { ITournamentAward } from '../typings';

interface IOwnProps {
  filters?: any;
  headers?: ITableHeader[];
  query?: any;
  pagination?: any;
  total?: number;
  onPaginate?: (change: any) => void;
  onSort?: (field: string) => void;
  onEdit?: (award: any) => void;
}

const mapStateToProps = (state: IRootState) => ({
  awards: state.tournamentAwards.list as ITournamentAward[],
  fetching: state.tournamentAwards.fetching as boolean,
  pagination: state.tournamentAwards.pagination,
  total: state.tournamentAwards.totalItems
});

const mapDispatchToProps = {
  fetchTournamentAwards
};

export type IComponentProps = typeof mapDispatchToProps & 
  ReturnType<typeof mapStateToProps> & 
  IOwnProps &
  InjectedIntlProps;

const reduxConnector = connect(
  mapStateToProps,
  mapDispatchToProps
);

export const connector = compose<IComponentProps, IOwnProps>(
  reduxConnector,
  injectIntl
);
